package org.catharsis.spendtel.feature.data

enum class FinancialGoal(
    val id: String,
    val title: String,
    val cloudLabel: String,
) {
    SaveMore("save_more", "Save more money", "Save\nmore"),
    PayOffDebt("pay_off_debt", "Pay off debt", "Pay off\ndebt"),
    EmergencyFund("emergency_fund", "Build an emergency fund", "Emergency\nfund"),
    ReduceSpending("reduce_spending", "Reduce unnecessary spending", "Spend\nless"),
    UnderstandHabits("understand_habits", "Understand my spending habits", "Spending\nhabits"),
    BigPurchase("big_purchase", "Save for a big purchase or trip", "Big\npurchase"),
    InvestMore("invest_more", "Invest more consistently", "Invest\nmore"),
    StickToBudget("stick_to_budget", "Stick to a monthly budget", "Monthly\nbudget"),
    ;

    companion object {
        val selectableGoals: List<FinancialGoal> = entries

        fun fromId(id: String?): FinancialGoal? {
            if (id.isNullOrBlank()) return null
            return entries.find { it.id == id }
        }
    }
}

fun SpendtelUser?.needsFinancialGoalSelection(): Boolean {
    return this == null || financialGoal.isNullOrBlank()
}
